module.exports = __webpack_public_path__ + "static/media/avast-ipod-achievment-3.76f53f46.png";